<template>
  <div>
    <v-textarea
      v-model="nodeDataLocale.textoSelecao"
      label="Mensagem *"
      placeholder="Digite uma Mensagem"
      outlined
      auto-grow
      rows="1"
      row-height="15"
      class="mt-2"
      :rules="[validators.required]"
      @change="nodeConfig"
    />

    <div
      v-if="isNodePai"
      class="my-4"
    >
      <span>Critério para pergunta adicional:</span>
    </div>

    <v-text-field
      v-if="isNodePai"
      v-model="nodeDataLocale.notaMenorQue"
      class="mt-2"
      label="Nota menor que:"
      outlined
      type="number"
      min="0"
      validate-on-blur
      :rules="[v => nodeDataLocale.perguntaAdicional ? !!v || 'Campo obrigatório' : true]"
    />

    <v-text-field
      v-if="isNodePai"
      v-model="nodeDataLocale.perguntaAdicional"
      class="mt-2"
      label="Exibir pergunta:"
      outlined
      validate-on-blur
      :rules="[v => nodeDataLocale.notaMenorQue ? !!v || 'Campo obrigatório' : true]"
    />
  </div>
</template>

<script>
import { computed, inject, ref, watch } from '@vue/composition-api'
import { required, select } from '@/@core/utils/validation'
import NodeChatBotModel from '@/models/entities/chat-bot/NodeChatBotModel'

export default {
  setup(props, { emit }) {
    const opcoes = ref([])
    function exibirOpcoesDoNo(data) {
      let concat = ''
      if (data.chatBotNoTipoId === 1) {
        if (data.nosFilhos.length > 0) {
          data.nosFilhos.forEach(element => {
            concat += `${element.numero} - ${element.texto}\n`
          })
        }
      }
      opcoes.value = concat
    }

    const nodeDataLocale = ref(new NodeChatBotModel())
    const nodeData = inject('nodeData')
    watch(
      () => nodeData.value,
      value => {
        nodeDataLocale.value = value
        exibirOpcoesDoNo(value)
      },
      { immediate: true, deep: true },
    )

    const isNodePai = computed(() => nodeData.value.noPaiId === null)

    const tipoIdPaiLocale = inject('nodeTipoIdPai')

    function nodeConfig() {
      emit('node-config')
    }

    return {
      nodeConfig,
      nodeDataLocale,
      tipoIdPaiLocale,
      opcoes,
      isNodePai,
      validators: {
        required,
        select,
      },
    }
  },
}
</script>
